import { ContractService } from './contract.service';

export const services: any[] = [ContractService];

export * from './contract.service';
